import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingAction,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

export const DIALOG_TYPE = 'update-client-email';

@Component({
  selector: 'app-update-client-email-dialog',
  templateUrl: './update-client-email-dialog.component.html',
  styleUrls: ['./update-client-email-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateClientEmailDialogComponent implements OnInit, OnChanges {
  @Input() clientName: string;
  @Input() documentType: DocumentTypesEnum;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  onUpdateClientEmail: EventEmitter<boolean> = new EventEmitter<boolean>();

  dialogType: string;
  trackingDialogName: TrackingDialogNamesEnum;
  primaryActionTrackingAction: ITrackingAction;
  secondaryActionTrackingAction: ITrackingAction;

  constructor(private _trackingActionBuilder: I2gNgTrackingActionBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.trackingScreenName && this.trackingScreenName) {
      this.primaryActionTrackingAction = this._trackingActionBuilder.buildButtonTapped(
        'update_send',
        this.trackingScreenName
      );
      this.secondaryActionTrackingAction = this._trackingActionBuilder.buildButtonTapped(
        'send',
        this.trackingScreenName
      );
    }
  }

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingDialogName = TrackingDialogNamesEnum.update_email;
  }
}
